<template>
  <div>
    <div id="app">
      <loads></loads>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'
import axios from 'axios'
import config from '@/conf'
import loads from '@/components/common/loads.vue'
export default {
  name: 'app',
  data(){
      return{
        wxconfig:{
          appId:"",
          timestamp:"",
          nonceStr:"",
          signature:""
          },
        locationUrl:"",
        shareUrl:"",
        shareTitle: `${config.shopnamechina}定制商城`, // 分享标题
        shareDesc: '舒适不将就，为你定制专属鞋款！', // 分享描述
        shareImgUrl: `${config.domainname}/static/img/${config.shopname}_logo.png` // 分享图标
      }
  },
  created(){
  },
  mounted(){
  },
  components: {
    loads,
  },
  methods:{
    getweinsdkinfo:function(){
      const self=this;
      axios.post('/v1/js.conf',{
        url:self.locationUrl
      })
        .then(function(res){
          self.wxconfig.appId = res.data.data.appId;
          self.wxconfig.timestamp = res.data.data.timestamp;
          self.wxconfig.nonceStr = res.data.data.nonceStr;
          self.wxconfig.signature = res.data.data.signature;
          self.init();
        })
        .catch(function(error){

        });
    },
    init:function(){
      const self=this;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId:  self.wxconfig.appId, // 必填，公众号的唯一标识
        timestamp:  self.wxconfig.timestamp, // 必填，生成签名的时间戳
        nonceStr: self.wxconfig.nonceStr, // 必填，生成签名的随机串
        signature: self.wxconfig.signature,// 必填，签名，见附录1
        jsApiList: ['onMenuShareAppMessage','onMenuShareTimeline','onMenuShareQQ','scanQRCode'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
      wx.ready(function(){
          //分享到朋友圈
        wx.onMenuShareTimeline({
          title: self.shareTitle, // 分享标题
          desc: self.shareDesc, // 分享描述
          link: self.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: self.shareImgUrl, // 分享图标
          success: function () {
            // 用户确认分享后执行的回调函数
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
          }
        });
        //分享给朋友
        wx.onMenuShareAppMessage({
          title: self.shareTitle, // 分享标题
          desc: self.shareDesc, // 分享描述
          link: self.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: self.shareImgUrl, // 分享图标
          type: '', // 分享类型,music、video或link，不填默认为link
          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
          success: function () {
            // 用户确认分享后执行的回调函数
            // alert('link -- ' + self.shareUrl)
            // alert('shopnamechina -- ' + config.shopnamechina)
            // alert('domainname -- ' + config.domainname)
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
            // alert('取消分享')
          },
          catch: function(){
            alert('catch')
          },
          error: function(){
            alert('error')
          },
        });
        //分享到QQ
        wx.onMenuShareQQ({
          title: self.shareTitle, // 分享标题
          desc: self.shareDesc, // 分享描述
          link: self.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: self.shareImgUrl, // 分享图标
          success: function () {
              // 用户确认分享后执行的回调函数
          },
          cancel: function () {
          // 用户取消分享后执行的回调函数
          }
        });
      });
      wx.error(function(res){
        if(!/-test/.test(document.URL) && /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)){
          location.reload()
        }
        // location.reload(); //ios首次进入signature失效
      });
      wx.checkJsApi({
        jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage','onMenuShareQQ','scanQRCode'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: function(res) {
          // 以键值对的形式返回，可用的api值true，不可用为false
          // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
          self.$store.state.isscan = true
        },
        cancel: function (err) {
          alert('jsApiList错误')
          alert(err)
        }
      });
    },
  },
  watch:{
    '$route' (to, from) {
      // console.log('触发路由监听了')
      //新用戶進來的時候  仅仅在第一次的时候回去appid，signature等四个值
      //刷新当前页面的时候 sendaToken是存在的 但是appid，signature等四个值是没有存在sessionStroge中，要重新获取
      //每切换一个页面都要重新注册分享地址，应为分享出去的地址是不一样的
      //分享地址规则   产品页面分享地址是产品页面   其他页面分享出去都是首页
      const self=this;
      var u = navigator.userAgent;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        self.locationUrl=location.href
      }
      if (isIOS) {
        self.locationUrl=location.href.split('#')[0]  //hash后面的部分如果带上ios中config会不对
      }
        // if(location.href.indexOf("commoditydetail")>-1){ // 在店和高端合并前
      if(to.path.indexOf("detailsofthebnedition")>-1){
        self.shareUrl = location.href.replace(/\/detailsofthebnedition\/.*?\?/,'/detailsofthebnedition?')
      }else if(to.path == '/coupondetailr' || to.path == '/couponReceive'){ // 请求的
        let showName = encodeURI(to.query.showName)
        if(!to.query.couponType){
          self.shareUrl = `${config.domainname}/#/couponReceive?recordId=${to.query.recordId}&showName=${showName}&parValue=${to.query.parValue}&couponType=3`;
          self.shareTitle = `送你一张${to.query.parValue-0}元${decodeURI(showName)}`
        }else{
          self.shareUrl = `${config.domainname}/#/couponReceive?recordId=${to.query.recordId}&showName=${showName}&parValue=${to.query.parValue}`;
          self.shareTitle = `送你一张${(to.query.parValue-0)/10}折${decodeURI(showName)}`
        }
      }else{
        self.shareUrl= `${config.domainname}`;
      }
        // alert('self.shareUrl-router --- ' + self.shareUrl)
      if(localStorage.getItem('epoqueToken')&&sessionStorage.getItem('epoqueToken')!=''){
          this.getweinsdkinfo();
      }
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/App.vue